import { FormattedMessage, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { AddressPropType } from '../../../../../../../prop-types/address';
import AddressValidationStatus from '../../../../../../../components/address-validation/validation-status';
import notValidatedSVG from '../svg/not-validated.svg';
import { UNV, VER } from '../../../../../../../enums/address-verification-status';

import messages from '../messages';
import style from '../edit-shipto-modal/edit-shipto-modal.module.less';

export const EditShiptoAddressValidation = ({ formState, isValid, isValidatingAddress, validateAddress, isSaving = false }) => {
  const intl = useIntl();
  const shouldDisableValidate = formState.verificationStatus === VER || isValidatingAddress || !isValid || isSaving;
  return (
    <FlexRow className={style['validate-address-section']}>
      <FlexColumn>
        <Button disabled={shouldDisableValidate} onClick={validateAddress} theme={THEME_CONSTANTS.tertiary}>
          <FormattedMessage {...messages.validate} />
        </Button>
      </FlexColumn>
      <FlexColumn>
        {!isValidatingAddress && formState.verificationStatus === UNV && (
          <Text
            className={style['validation-text']}
            formattedMessageValues={{
              icon: (
                <img alt={intl.formatMessage(messages.notValidatedNoIcon)} className={style['validation-icon']} src={notValidatedSVG} />
              ),
            }}
            value={messages.notValidated}
          />
        )}
        {!isValidatingAddress && formState.verificationStatus !== UNV && (
          <AddressValidationStatus
            countryCode={formState.countryCode}
            hideValidateButton
            residentialIndicator={formState.residentialIndicator}
            validation={formState.verificationStatus}
            validationMessage={formState.verificationMessage}
          />
        )}
        {isValidatingAddress && (
          <Text
            className={style['validation-text']}
            formattedMessageValues={{
              spinner: <LoadingIndicator className={style['validation-loading-icon']} />,
            }}
            textType={TextType.Description}
            value={messages.validating}
          />
        )}
      </FlexColumn>
    </FlexRow>
  );
};

EditShiptoAddressValidation.propTypes = {
  formState: AddressPropType.isRequired,
  isValid: PropTypes.bool.isRequired,
  isValidatingAddress: PropTypes.bool.isRequired,
  validateAddress: PropTypes.func.isRequired,
  isSaving: PropTypes.bool,
};
